import * as React from 'react'
import styled from 'styled-components'
import reload from '../img/reload.png'

export default () => {
  return <Icon src={reload} />
}

const Icon = styled.img`
  animation: spin 1s infinite linear;

  @keyframes spin {
    from {
      transform: scale(1) rotate(0deg);
    }
    to {
      transform: scale(1) rotate(360deg);
    }
  }
`



// WEBPACK FOOTER //
// ./src/shared/LoaderIcon.tsx